import { ReactNode } from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

import { Icon, IconType } from '../icon';

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    fontSize: theme.elements.icon.size.xl,
    color: theme.palette.grey['800'],
    marginRight: theme.spacing(1)
  }
}));

interface Props {
  children: ReactNode;
  icon?: IconType;
}

export const DialogDescription = ({ children, icon }: Props) => {
  const classes = useStyles();

  return (
    <Box display="flex" alignItems="center">
      {icon && <Icon icon={icon} className={classes.icon} />}
      <Typography>{children}</Typography>
    </Box>
  );
};
